<script>
  import { setContext } from "svelte";

  export let vertical = false;

  setContext("progress-vertical", vertical);
</script>

<ol class="progress-indicator" class:vertical>
  <slot />
</ol>

<style>
  .progress-indicator {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 0;
  }

  .progress-indicator.vertical {
    flex-direction: column;
  }
</style>
